import { posts } from "@/data/content";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function BlogListPage() {
  return (
    <main data-testid="blog-list-page" className="pt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="overline mb-4">Journal</p>
        <h1 className="font-serif-display text-5xl sm:text-6xl tracking-tight max-w-3xl">
          Field notes on Australian <span className="italic text-[#36C281]">property investment</span>.
        </h1>
        <p className="text-neutral-400 mt-6 max-w-2xl text-lg leading-relaxed">
          Frameworks, market reads and lessons from real deals — written for investors who think in decades, not weeks.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {posts.map((p, i) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${i}`}
              className="group cursor-pointer"
            >
              <div className="overflow-hidden border border-neutral-800">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="text-xs text-[#36C281] mt-6 tracking-[0.2em] uppercase">{p.date}</div>
              <h2 className="font-serif-display text-2xl mt-3 group-hover:text-[#36C281] transition-colors">
                {p.title}
              </h2>
              <p className="text-neutral-400 mt-3 text-sm leading-relaxed">{p.excerpt}</p>
              <span className="inline-flex items-center gap-2 text-xs text-neutral-400 mt-5 group-hover:text-[#36C281] transition-colors">
                Read article <ArrowRight size={14} />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
